// src/components/PrivateRoute.js
import React from "react";
import { Route, Redirect } from "react-router-dom";
import { isTokenExpired } from "../../../utils/auth";

const PrivateRoute = ({ component: Component, ...rest }) => {
  const token = localStorage.getItem("jwt");

  const isAuthenticated = token && !isTokenExpired(token);

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect to="/page-login" />
        )
      }
    />
  );
};

export default PrivateRoute;
